// extracted by mini-css-extract-plugin
export var closeButton = "_6g-0";